export default __webpack_public_path__ + "static/media/qnb-logo.0a614d69.png";